import { CompanyCommissions } from '../modules/sales/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import { PageHeader } from './page-title.js';

export function CompanyCommissionsScreen({
  onOpenExpenses,
}: {
  onOpenExpenses?: ((professional: string) => void) | undefined;
}) {
  const { can, today, company } = useCompanyScope();
  const canRead = can('sales.commissions.read');
  const canReadOwn = can('sales.commissions.read_own');
  const activeUnit = (company.businessUnits ?? []).find(
    (unit) => unit.id === company.activeBusinessUnitId,
  );
  return (
    <GatedCompanyScreen allowed={canRead || canReadOwn}>
      {/* Só estabelecimento atende e vende com profissional (ADR 0039; ADR 0082, decisão 29). */}
      {activeUnit?.kind === 'SUPPORT' ? (
        <section>
          <PageHeader
            trail="Vendas / Comissões"
            title="Comissões"
            description={`${activeUnit.displayName} é uma unidade de apoio e não tem comissões. Troque para um estabelecimento no seletor de unidade.`}
          />
        </section>
      ) : (
        <CompanyCommissions
          today={today}
          canRead={canRead}
          canClose={can('sales.commissions.close')}
          canReadOwn={canReadOwn}
          onOpenExpenses={
            company.moduleKeys.includes('finance') && can('financial_obligations.read')
              ? onOpenExpenses
              : undefined
          }
        />
      )}
    </GatedCompanyScreen>
  );
}
